"use strict";
import { Button, Dialog, Icons, Intent, Size } from "construct-ui";
import 'CssFolder/survey/survey-list-item.scss';
import UserBadgeComponent from "../../components/common/user-badge.component";
// import { SURVEY_TYPES } from "../../config/constants";
import ViewBase from "../view-base.view";
import ExportQuickSurveyView from "./export-quick-survey.view";

export default function SurveyListItemView() {
  ViewBase.call(this);

  let survey;
  let showQuickSurveyDownloadModal = false;

  let onCheckboxChange = (surveyId, isChecked) => { };
  let viewUpdateSurveyQuestions = () => { };
  let viewUpdateSurveyInfo = () => { };
  let downloadExcelForTargetResponse = () => { };

  return {
    oninit: (vnode) => {
      if (vnode.attrs.survey) {
        survey = vnode.attrs.survey;
      }
      if (vnode.attrs.onCheckboxChange) {
        onCheckboxChange = vnode.attrs.onCheckboxChange;
      }
      if (vnode.attrs.viewUpdateSurveyQuestions) {
        viewUpdateSurveyQuestions = vnode.attrs.viewUpdateSurveyQuestions;
      }
      if (vnode.attrs.viewUpdateSurveyInfo) {
        viewUpdateSurveyInfo = vnode.attrs.viewUpdateSurveyInfo;
      }
      if (vnode.attrs.downloadExcelForTargetResponse) {
        downloadExcelForTargetResponse = vnode.attrs.downloadExcelForTargetResponse;
      }
    },
    view: (vnode) => {
      return [
        m('.survey-item.card',
          m('span.survey-type-bar', { style: { backgroundColor: vnode.attrs.surveyColorCode } }),
          m('.card-body',
            m('input.form-check-input.flex-shrink-0[type=checkbox]', {
              checked: vnode.attrs.isSelected,
              onchange: (e) => {
                onCheckboxChange(survey.surveyIdString, Boolean(e.target.checked))
              }
            }),
            m('.survey-item-content',
              m('.survey-item-content__top',
                // User Info Section
                m('.survey-user',
                  m(UserBadgeComponent, {
                    image: survey.photoString,
                    imageSize: '48px',
                  }, [
                    m('.d-flex.flex-column.gap-2',
                      m('.user-name', { title: survey.createUserName }, survey.createUserName),
                      m('.survey-type',
                        m('label.me-1', this.getText("LT00000519", "Type / Frequency"), ':'),
                        m('div', `${survey.type ? survey.type : '-'} / ${survey.frequency ? survey.frequency : '-'}`)
                      )
                    )
                  ]),
                ),
                // Survey Info
                m('.survey-info',
                  m('.survey-title', m('a[href="javascript:void(0);"]', {
                    title: this.getText("LT00000520", "View / Update Survey Information"),
                    onclick: viewUpdateSurveyInfo
                  },
                    m('span.fw-bold', `[#${survey.surveyIdString}] `, survey.title)
                  )),
                  m('.survey-category', survey.category),
                  m('.survey-user', `${survey.fromDate} ~ ${survey.toDate}`)
                ),
                // Survey Question Info
                m('.survey-question',
                  m('.survey-question-count',
                    m('label.me-1', this.getText("LT00000521", "No. of Questions"), ':'),
                    survey.numberOfQuestions ?? '-'
                  ),
                  m('.survey-target-response',
                    m('label.me-1', this.getText("LT00000522", "Target / Response"), ':'),
                    m('a[href="javascript:void(0);"]', {
                      title: this.getText("LT00000523", "Download Target / Response Summary"),
                      onclick: downloadExcelForTargetResponse
                    },
                      `${survey.targetNo ?? '-'} / ${survey.responseNo ?? '-'} (${survey.responseRate.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%)`
                    ),
                  )
                ),
                // Action buttons
                m('.survey-actions',
                  m(Button, {
                    iconLeft: Icons.EDIT_2,
                    intent: Intent.PRIMARY,
                    label: this.getText("LT00000524", "Manage"),
                    outlined: true,
                    rounded: true,
                    size: Size.XS,
                    onclick: viewUpdateSurveyQuestions
                  }),
                  survey.downloadYN === 'Y' &&
                  m(Button, {
                    iconLeft: Icons.DOWNLOAD,
                    intent: Intent.PRIMARY,
                    label: this.getText("LT00000492", "Download"),
                    outlined: true,
                    rounded: true,
                    size: Size.XS,
                    onclick: () => showQuickSurveyDownloadModal = true,
                  })
                ),
              ),
              m('hr'),
              m('.survey-item-content__bottom',

                m('.flex-grow-1.d-flex.flex-wrap.gap-4',
                  m('label', { style: 'white-space: nowrap;' },
                    m('.inline-label-with-point'),
                    this.getText("LT00000273", "Created By") + " : " + survey.createUserId + ' | ' + survey.createDate
                  ),
                  m('label', { style: 'white-space: nowrap;' },
                    m('.inline-label-with-point'),
                    this.getText("LT00000274", "Updated By") + " : " + survey.updateUserId + ' | ' + survey.updateDate
                  ),
                ),
                m('.survey-question', survey.active === 'Y' ? m('span.badge.rounded-pill.active', this.getText("", "Active")) : m('span.badge.rounded-pill.inactive', this.getText("", "Inactive"))),
                m('.survey-actions',
                  survey.surveyAnswerEditYN === 'Y' && m(Button, {
                    iconLeft: Icons.LIST,
                    intent: Intent.PRIMARY,
                    label: this.getText("", "Responses"),
                    outlined: true,
                    rounded: true,
                    size: Size.XS,
                    onclick: vnode.attrs.onResponseClick,
                  })
                )
              ),
            ),
          )
        ),
        m(Dialog, {
          closeOnOutsideClick: false,
          isOpen: showQuickSurveyDownloadModal,
          onClose: (e) => { showQuickSurveyDownloadModal = false; },
          title: m("div", [
            m("h3", this.getText("LT00000525", "Export Quick Survey") + ' - ' + survey.title),
            m("p.fw-light.mb-0", `Survey Date: ${survey.fromDate} ~ ${survey.toDate}`)]),
          content: m(ExportQuickSurveyView, {
            data: survey,
            closeModal: e => showQuickSurveyDownloadModal = false
          }),
        })
      ]
    }
  }
}
